const Config = {
    API_URL: process.env.REACT_APP_API_URL,
    // FORMS_account: 'https://v2-dev.trellisplatform.com/api/v1/account',
    // TAPP_ID: 'f48b4af1-4e7d-4283-801e-d42e245c37c5',
    // FORMS_AUTH_SECRET: 'NYHeacpSaBSKssFPnJj7lQTBEdFBLTqNfdWpVCV31xRrxT6EVsrSIwJfRS5Q7bOS'
}
export default Config